import React, { useState } from 'react';
import { Mail, ArrowRight, CheckCircle2, AlertCircle, Lock } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
export function RecoverPassword() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setIsSubmitted(true);
    }, 1500);
  };
  return <div className="min-h-screen bg-gray-50 pt-40 lg:pt-52 pb-20" data-id="element-1493">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1494">
        {!isSubmitted ? <>
            {/* Page Header */}
            <div className="text-center mb-8" data-id="element-1495">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-purple-100 rounded-full mb-4" data-id="element-1496">
                <Lock className="w-8 h-8 text-brand-purple-600" data-id="element-1497" />
              </div>
              <h1 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-1498">
                Forgot Your Password?
              </h1>
              <p className="text-lg text-gray-600" data-id="element-1499">
                No problem! Enter your email address and we'll send you a link
                to reset your password.
              </p>
            </div>

            {/* Help Tips */}
            <Card className="p-6 mb-8 bg-blue-50 border-blue-200" data-id="element-1500">
              <h3 className="font-semibold text-blue-900 mb-3 flex items-center" data-id="element-1501">
                <AlertCircle className="w-5 h-5 mr-2" data-id="element-1502" />
                Password Not Working? Here Are a Few Suggestions:
              </h3>
              <ul className="space-y-2 text-sm text-blue-800" data-id="element-1503">
                <li className="flex items-start" data-id="element-1504">
                  <span className="font-semibold mr-2" data-id="element-1505">1.</span>
                  <span data-id="element-1506">
                    Look at your original registration email titled "Welcome to
                    Desert Sage Seminars". That email contains your username.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1507">
                  <span className="font-semibold mr-2" data-id="element-1508">2.</span>
                  <span data-id="element-1509">
                    Your browser may be saving an incorrect password. Try
                    clearing the password box and re-type the correct password.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1510">
                  <span className="font-semibold mr-2" data-id="element-1511">3.</span>
                  <span data-id="element-1512">
                    BEFORE resetting your password, add
                    Administration@DesertSageSeminars.com to your Safe Senders
                    list so that you can receive our emails.
                  </span>
                </li>
              </ul>
            </Card>

            {/* Reset Form */}
            <Card className="p-8" data-id="element-1513">
              <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1514">
                Reset Your Password
              </h2>

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1515">
                <div data-id="element-1516">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1517">
                    Email Address<span className="text-red-500" data-id="element-1518">*</span>
                  </label>
                  <div className="relative" data-id="element-1519">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1520">
                      <Mail className="h-5 w-5 text-gray-400" data-id="element-1521" />
                    </div>
                    <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" placeholder="Enter your email address" required data-id="element-1522" />
                  </div>
                  <p className="mt-2 text-sm text-gray-500" data-id="element-1523">
                    Enter the email address associated with your account
                  </p>
                </div>

                <Button type="submit" className="w-full font-semibold" size="lg" isLoading={isLoading} data-id="element-1524">
                  Send Reset Link <ArrowRight className="ml-2 h-4 w-4" data-id="element-1525" />
                </Button>
              </form>

              <div className="mt-6 pt-6 border-t border-gray-200 text-center" data-id="element-1526">
                <p className="text-sm text-gray-600" data-id="element-1527">
                  Remember your password?{' '}
                  <a href="/login-register" className="font-medium text-brand-purple-600 hover:text-brand-purple-700 hover:underline" data-id="element-1528">
                    Back to Login
                  </a>
                </p>
              </div>
            </Card>

            {/* Support Section */}
            <div className="mt-8 text-center" data-id="element-1529">
              <p className="text-sm text-gray-600 mb-2" data-id="element-1530">
                Still having trouble?
              </p>
              <a href="/Contact" className="text-sm font-medium text-brand-purple-600 hover:text-brand-purple-700 hover:underline" data-id="element-1531">
                Contact our support team
              </a>
              <p className="text-sm text-gray-500 mt-1" data-id="element-1532">
                or call us at{' '}
                <a href="tel:602-377-6207" className="font-semibold text-gray-700 hover:text-brand-purple-600" data-id="element-1533">
                  602-377-6207
                </a>
              </p>
            </div>
          </> /* Success Message */ : <Card className="p-8 text-center" data-id="element-1534">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4" data-id="element-1535">
              <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-1536" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-1537">
              Check Your Email
            </h2>
            <p className="text-lg text-gray-600 mb-6" data-id="element-1538">
              We've sent a password reset link to:
            </p>
            <p className="text-lg font-semibold text-brand-purple-600 mb-6" data-id="element-1539">
              {email}
            </p>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-left" data-id="element-1540">
              <h3 className="font-semibold text-blue-900 mb-2" data-id="element-1541">Next Steps:</h3>
              <ol className="space-y-2 text-sm text-blue-800" data-id="element-1542">
                <li className="flex items-start" data-id="element-1543">
                  <span className="font-semibold mr-2" data-id="element-1544">1.</span>
                  <span data-id="element-1545">
                    Check your email inbox for a message from Desert Sage
                    Seminars
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1546">
                  <span className="font-semibold mr-2" data-id="element-1547">2.</span>
                  <span data-id="element-1548">Click the password reset link in the email</span>
                </li>
                <li className="flex items-start" data-id="element-1549">
                  <span className="font-semibold mr-2" data-id="element-1550">3.</span>
                  <span data-id="element-1551">Create a new password for your account</span>
                </li>
              </ol>
            </div>
            <p className="text-sm text-gray-600 mb-6" data-id="element-1552">
              Didn't receive the email? Check your spam folder or{' '}
              <button onClick={() => setIsSubmitted(false)} className="font-medium text-brand-purple-600 hover:text-brand-purple-700 hover:underline" data-id="element-1553">
                try again
              </button>
            </p>
            <Button onClick={() => window.location.href = '/login-register'} variant="outline" size="lg" data-id="element-1554">
              Back to Login
            </Button>
          </Card>}
      </div>
    </div>;
}